import { Injectable } from '@angular/core';
import { FirebaseCrashlytics } from '@capacitor-firebase/crashlytics';
import * as StackTrace from 'stacktrace-js';

@Injectable({
  providedIn: 'root',
})
export class CrashlyticsService {
  async crash() {
    await FirebaseCrashlytics.crash({ message: 'Simula un CRASH intencional' });
  }

  async setCustomKey(key: string, value: string, type: 'string' | 'boolean' | 'int' | 'float') {
    await FirebaseCrashlytics.setCustomKey({ key, value, type });
  }

  async setUserId(userId: string) {
    await FirebaseCrashlytics.setUserId({ userId });
  }

  async log(message: string) {
    await FirebaseCrashlytics.log({ message });
  }

  async setEnabled(enabled: boolean) {
    await FirebaseCrashlytics.setEnabled({ enabled });
  }

  async isEnabled(): Promise<boolean> {
    const { enabled } = await FirebaseCrashlytics.isEnabled();
    return enabled;
  }

  async didCrashOnPreviousExecution(): Promise<boolean> {
    const { crashed } = await FirebaseCrashlytics.didCrashOnPreviousExecution();
    return crashed;
  }

  async sendUnsentReports() {
    await FirebaseCrashlytics.sendUnsentReports();
  }

  async deleteUnsentReports() {
    await FirebaseCrashlytics.deleteUnsentReports();
  }

  async recordException(message: string) {
    await FirebaseCrashlytics.recordException({ message });
  }

  async recordExceptionWithStacktrace(error: Error, message = 'Error no fatal') {
    const stacktrace = await StackTrace.fromError(error);
    await FirebaseCrashlytics.recordException({ message, stacktrace });
  }
}